import Swiper, { Mousewheel, Navigation } from 'swiper';

const bundleBuilderProductGallery = (product) => ({
  product: product,
  swiper: null,

  init() {
    this.initializeGallery();
  },

  initializeGallery() {
    const el = this.$root.querySelector(`.swiper`);
    if (!el || this.swiper) return;

    this.swiper = new Swiper(el, {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        disabledClass: 'swiper-button-hidden',
      },
      grabCursor: true,
      preloadImages: false,
      slidesPerView: 1,
      spaceBetween: 32,
    });
  },
});

export default bundleBuilderProductGallery;
